import { render, staticRenderFns } from "./RailwayCalculator.vue?vue&type=template&id=a0613a0a&scoped=true&"
import script from "./RailwayCalculator.vue?vue&type=script&lang=js&"
export * from "./RailwayCalculator.vue?vue&type=script&lang=js&"
import style0 from "./RailwayCalculator.vue?vue&type=style&index=0&id=a0613a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0613a0a",
  null
  
)

export default component.exports